import { Box } from '@material-ui/core'
import { lighten } from '@material-ui/core/styles'
import { styled } from '@material-ui/core/styles'
import { Pill } from '@scoir/pills'

import ScoirIcon from './ScoirIcon'

const ScoirPill = styled(Pill)(({ theme }) => {
  return {
    background: lighten(theme.palette.info.light, 0.9),
  }
})
const ScoirBadgeIconContainer = styled(Box)(({ theme }) => ({
  fill: '#15769a',
  marginRight: theme.spacing(0.5),
  height: 25,
  width: 25,
}))

export default function OnScoirBadge() {
  return (
    <ScoirPill>
      <ScoirBadgeIconContainer>
        <ScoirIcon />
      </ScoirBadgeIconContainer>
      On Scoir
    </ScoirPill>
  )
}
